'use client'
import React, { ReactNode } from 'react'
import { Button } from '../ui/button'
import { Loader2 } from 'lucide-react'

export interface ActionButtonProps {
  title: string | ReactNode
  type?: 'button' | 'submit' | 'reset'
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  loading?: boolean
  icon?: ReactNode
  className?: string
  iconPosition?: 'start' | 'end'
  loadingText?: string
  size?: 'sm' | 'md' | 'lg' | 'icon' | null | undefined
  variant?: 'primary' | 'secondary'
}

const ActionButton: React.FC<ActionButtonProps> = ({
  title = '',
  onClick,
  disabled = false,
  loading = false,
  icon,
  className = '',
  type = 'button',
  iconPosition = 'start',
  loadingText = 'Loading',
  size,
  variant = 'primary',
}) => {
  const buttonVariant =
    variant === 'primary' ? 'agilus_primary' : 'agilus_secondary'

  return (
    <Button
      type={type}
      size={size}
      variant={buttonVariant}
      className={`h-auto ${className}`}
      data-title={typeof title === 'string' ? title : undefined}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <span className="relative z-[2] flex gap-2 items-center">
        {loading ? (
          <>
            <Loader2 size={18} className="animate-spin" /> {loadingText}
          </>
        ) : (
          <>
            {iconPosition === 'start' && icon}
            {title}
            {iconPosition === 'end' && icon}
          </>
        )}
      </span>
    </Button>
  )
}

export default ActionButton
